<template>
  <div class="searchpage">
    <div class="searchTop">
      <input placeholder="请输入搜索内容" v-model="searchinput" />
      <div class="searchBtn" @click="searchBtn">搜索</div>
    </div>
    <div class="searchContent">
      <newlist :cid-list="cidList"></newlist>
    </div>
  </div>
</template>

<script>
import "@assets/css/search.css";
import "@assets/css/newlist.css";
import newlist from "@components/newlist";
import { getHomeData, getShare, follow, getArticleListNew } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {
    newlist
  },
  props: {},
  data: function() {
    return {
      searchinput: "",
      page: 1,
      cidList: [],
      jiaochengDialog: false,
      listContent: false,
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      mapKey: "",
      isaddmore: true
    };
  },
  created() {
    vm = this;
  },
  mounted: function() {
    vm.setOpenShare();
    window.addEventListener("scroll", this.scrollBottom);
  },
  methods: {
    searchBtn() {
      this.page = 1;
      this.cidList = [];
      var data = "0?limit=30&page=" + this.page + "&title=" + this.searchinput;
      getArticleListNew(data)
        .then(res => {
          if (res.data.length <= 0) {
            this.isaddmore = false;
            return this.$dialog.error("未搜索到相关行业数据！");
          } else {
            this.cidList = this.cidList.concat(res.data);
            if (res.data.length < 20) {
              this.isaddmore = false;
            } else {
              this.isaddmore = true;
            }
          }
        })
        .catch(err => {
          return this.$dialog.error("未搜索到相关行业数据！");
        });
    },
    getList() {
      if (this.isaddmore) {
        this.isaddmore = false;
        var data =
          "0?limit=30&page=" + this.page + "&title=" + this.searchinput;
        getArticleListNew(data)
          .then(res => {
            if (res.data.length <= 0) {
              this.isaddmore = false;
              return this.$dialog.error("未搜索到相关行业数据！");
            } else {
              this.cidList = this.cidList.concat(res.data);
              if (res.data.length < 20) {
                this.isaddmore = false;
              } else {
                this.isaddmore = true;
              }
            }
          })
          .catch(err => {
            return this.$dialog.error("未搜索到相关行业数据！");
          });
      }
    },
    scrollBottom() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      let bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 80;
      console.log(scrollHeight);
      if (scrollTop != 0 && bottomOfWindow && this.isaddmore == true) {
        this.page = this.page + 1;
        this.getList();
      }
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jdbeautycm.congwa.xyz",
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style></style>
